import React from 'react';
import { Box, TextField, IconButton, InputAdornment } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from 'react-i18next';
interface AIAssistantInputProps {
	input: string;
	handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	handleKeyPress: (e: React.KeyboardEvent) => void;
	handleSendMessage: () => void;
	disabled?: boolean;
	isMobile?: boolean;
	isXs?: boolean;
}

const AIAssistantInput: React.FC<AIAssistantInputProps> = ({
	input,
	handleInputChange,
	handleKeyPress,
	handleSendMessage,
	disabled = false,
	isMobile = false,
	isXs = false
}) => {
	const { t } = useTranslation();
	return (
		<Box
			sx={{
				width: '100%',
				boxSizing: 'border-box',
				pb: isXs ? 0.25 : isMobile ? 0.5 : 1,
				px: isXs ? 0.25 : isMobile ? 0.5 : 2
			}}
		>
			<TextField
				fullWidth
				variant="outlined"
				placeholder={t('pages.aiAssistant.placeholder')}
				value={input}
				onChange={handleInputChange}
				onKeyPress={handleKeyPress}
				sx={{
					width: '100%',
					'& .MuiOutlinedInput-root': {
						borderRadius: isXs ? 3 : 4,
						width: '100%',
						boxSizing: 'border-box',
						backgroundColor: (theme: any) =>
							theme.palette.mode === 'dark' ? 'rgba(0, 30, 69, 0.7)' : 'rgba(255, 255, 255, 0.7)',
						// padding: isXs ? '6px 10px' : isMobile ? '8px 12px' : '10px 14px',
						fontSize: isXs ? '0.85rem' : isMobile ? '0.9rem' : '1rem',
						'&.Mui-focused': {
							boxShadow: '0 0 0 2px rgba(33, 150, 243, 0.2)'
						},
						'& fieldset': {
							borderColor: (theme: any) =>
								theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)'
						},
						'&:hover fieldset': {
							borderColor: 'rgba(33, 150, 243, 0.5)'
						}
					}
				}}
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							<IconButton
								color="primary"
								disabled={input.trim() === '' || disabled}
								onClick={handleSendMessage}
								edge="end"
								sx={{
									ml: isXs ? 0.25 : 0.5,
									width: isXs ? 28 : isMobile ? 32 : 36,
									height: isXs ? 28 : isMobile ? 32 : 36
								}}
							>
								<SendIcon fontSize={isXs ? 'small' : 'medium'} />
							</IconButton>
						</InputAdornment>
					)
				}}
			/>
		</Box>
	);
};

export default AIAssistantInput;
